import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private http: HttpClient) { }

  dxSearch(query: string) {
    const endpoint = 'https://apps.pacmedservices.com/fmi/data/v1/databases/DxSearch/layouts/DxSearch/_find';
    const dxtoken = localStorage.getItem('dxtoken');
    const auth = 'Bearer ' + dxtoken;
    const body = '{\"query\": [' + '{\"ICD10concat\": \"' + query + '\"}],  "sort":[ { "fieldName": "ICD10", "sortOrder": "ascend" } ] }';

    return this.http.post(endpoint, body, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*')
        .set('Authorization', auth)
    });
  }

  dxYear() {
    const endpoint = 'https://apps.pacmedservices.com/fmi/data/v1/databases/DxSearch/layouts/Startup/_find';
    const dxtoken = localStorage.getItem('dxtoken');
    const auth = 'Bearer ' + dxtoken;
    const body = '{\"query\": [' + '{\"YEAR\": \"*\"}] }';

    return this.http.post(endpoint, body, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*')
        .set('Authorization', auth)
    });
  }


}
